import Slider from 'react-slick'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import ResponsiveImage from '../../../components/ResponsiveImage'
import { useDefault } from '../../../hooks/useDefault'
import {
  AccountsWrapper,
  BodyWrapper,
  Card,
  FooterItem,
  FooterText,
  FooterTitle,
  FooterWrapper,
  HeaderWrapper,
  Identity,
  ImageWrapper,
  SlideItem,
  StoreName,
  VideoWrapper,
} from '../styles/feed.styles'
import { useFeedModalStore } from '../store/feed-modal-store'
import ProductCardRelated from './product-card-related'

/* ---------- Accounts Component ---------- */
const Accounts = ({ seller }) => {
  const { id, picture, storeName, username } = seller

  const handleOnClick = e => {
    e.stopPropagation()
    window.location.href = `/store/${username}`
  }

  return (
    <AccountsWrapper key={id} onClick={handleOnClick}>
      <ResponsiveImage
        alt={username}
        src={picture}
        type='avatar'
        width='50'
        height='50'
        className='__avatar'
        style={{ objectFit: 'cover' }}
      />

      <Identity>
        <StoreName>{storeName}</StoreName>
      </Identity>
    </AccountsWrapper>
  )
}

/* ---------- Header ---------- */
const Header = ({ item }) => {
  const { seller } = item
  return (
    <HeaderWrapper>
      <Accounts seller={seller} />
    </HeaderWrapper>
  )
}

/* ---------- Media Carousel ---------- */
const MediaCarousel = ({ media = [], product }) => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    swipeToSlide: true,
    adaptiveHeight: true,
  }

  return (
    <BodyWrapper>
      <Slider {...settings}>
        {media.map((item, idx) => {
          const hasRelatedProduct = product !== null
          const handleImageOnClick = e => {
            e.stopPropagation()
            // console.log('Clicked on media item:', item)
          }
          return (
            <SlideItem key={idx}>
              {item.type === 'video' ? (
                <VideoWrapper onClick={e => e.stopPropagation()}>
                  <iframe
                    src={item.value || item.url}
                    frameBorder='0'
                    allow='autoplay; encrypted-media'
                    allowFullScreen
                    title={`video-${idx}`}
                  />
                </VideoWrapper>
              ) : (
                <ImageWrapper onClick={handleImageOnClick}>
                  <ResponsiveImage
                    src={item.value || item.url}
                    alt={`image-${idx}`}
                    onError={e => {
                      e.target.onerror = null
                      e.target.src = useDefault.getDefaultImageProduct
                    }}
                  />
                </ImageWrapper>
              )}
              {hasRelatedProduct && (
                <ProductCardRelated
                  onClick={e => e.stopPropagation()}
                  item={product}
                />
              )}
            </SlideItem>
          )
        })}
      </Slider>
    </BodyWrapper>
  )
}

const Body = ({ item }) => {
  const { medium, product } = item
  const data = [...medium]
  return <MediaCarousel media={data} product={product || null} />
}

/* ---------- Footer ---------- */
const Footer = ({ item }) => {
  const { text, title } = item

  return (
    <FooterWrapper>
      <FooterItem>
        <FooterTitle>{title}</FooterTitle>
        <FooterText>{text}</FooterText>
      </FooterItem>
    </FooterWrapper>
  )
}

/* ---------- FEED ---------- */
const Feed = ({ item, withScale = false, disable = false }) => {
  const { id } = item
  const handleOpen = useFeedModalStore(s => s.handleOpen)
  return (
    <Card
      key={id}
      withScale={withScale}
      onClick={() => (!disable ? handleOpen(item) : null)}
    >
      <Header item={item} />
      <Body item={item} />
      <Footer item={item} />
    </Card>
  )
}

export default Feed
